exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2Y32{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_2Y32",
	"root": "_2Y32"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/SidebarBlogue/SidebarBlogue.css
// module id = 222
// module chunks = 0